export default __webpack_public_path__ + "static/media/ne.2318b88e.jpg";